import React from 'react';
import './StarfieldBackground.css';

const StarfieldBackground = () => {
  return (
    <div className="starfield-bg">
      <div className="starfield-bg__stars-1" />
      <div className="starfield-bg__stars-2" />
      <div className="starfield-bg__stars-3" />
    </div>
  );
};

export default StarfieldBackground;